import { Theme, Typography } from '@mui/material';
import { ChonkyActions } from '../../action-definitions';

import { thunkRequestFileAction } from '../../redux/thunks/dispatchers.thunks';
import { ChonkyIconName } from '../../types/icons.types';
import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { ChonkyIconContext } from '../../util/icon-helper';
import { ChonkyTheme } from '../../util/styles';

export const ListHeader: React.FC = React.memo(() => {
  // // const entryState: FileEntryState = useFileEntryState(file, selected, focused)
  // const entryState: FileEntryState = useFileEntryState(file, false, focused);
  // const dndIconName = useDndIcon(dndState);

  // const { fileModDateString, fileSizeString } = useLocalizedFileEntryStrings(
  //   file
  // );
  // const styleState = useMemo<StyleState>(
  //   () => ({
  //     entryState,
  //     dndState,
  //   }),
  //   [dndState, entryState]
  // );
  const dispatch = useDispatch();
  const classes = useStyles();
  const ChonkyIcon = useContext(ChonkyIconContext);
  return (
    <div className={classes.listFileEntry}>
      <div className={classes.listFileEntrySelection}></div>
      <div className={classes.listFileEntryIcon}>
        <ChonkyIcon icon={ChonkyIconName.list} spin={false} fixedWidth={true} />
      </div>
      <div
        className={classes.listFileEntryName}
        onClick={() =>
          dispatch(
            thunkRequestFileAction(
              ChonkyActions.SortFilesByName,
              undefined
            ) as any
          )
        }
      >
        <Typography variant="body1">Name</Typography>
      </div>
      <div
        className={classes.listFileEntryProperty}
        onClick={() =>
          dispatch(
            thunkRequestFileAction(
              ChonkyActions.SortFilesByDate,
              undefined
            ) as any
          )
        }
      >
        <Typography variant="body1">Date</Typography>
      </div>
      <div
        className={classes.listFileEntryProperty}
        onClick={() =>
          dispatch(
            thunkRequestFileAction(
              ChonkyActions.SortFilesBySize,
              undefined
            ) as any
          )
        }
      >
        <Typography variant="body1">Size</Typography>
      </div>
    </div>
  );
});

const useStyles = createUseStyles((theme: ChonkyTheme & Theme) => ({
  listFileEntry: {
    boxShadow: `inset ${theme.palette.divider} 0 -1px 0`,
    fontSize: theme.listFileEntry.fontSize,
    color: 'inherit',
    alignItems: 'center',
    position: 'relative',
    display: 'flex',
    // height: '100%',
  },
  listFileEntrySelection: {
    opacity: 0.6,
  },
  listFileEntryIcon: {
    color: 'inherit',
    fontSize: theme.listFileEntry.iconFontSize,
    boxSizing: 'border-box',
    padding: [2, 4],
    zIndex: 20,
  },
  listFileEntryName: {
    textOverflow: 'ellipsis',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flex: '1 1 300px',
    paddingLeft: 8,
    zIndex: 20,
  },
  listFileEntryProperty: {
    fontSize: theme.listFileEntry.propertyFontSize,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flex: '0 1 150px',
    padding: [2, 8],
    zIndex: 20,
  },
}));
